import axios from 'axios';
import { apiDomain } from '@/config';
import de from '@/data/countries/de.json';
import it from '@/data/countries/it.json';
import fr from '@/data/countries/fr.json';
import en from '@/data/countries/en.json';
import * as types from './types';

const countries = {
  de, it, fr, en,
};

const actions = {
  resetState: ({ commit }) => {
    commit(types.RESET_STATE);
  },
  setCountries: ({ rootState, commit }, language) => {
    const array = Object.entries(countries[language]).map((item) => {
      const [iso, name] = item;
      const country = { iso, name };
      return country;
    });
    commit(types.SET_COUNTRIES, array);
  },
  async fetchMedia({ rootState, commit, dispatch }) {
    commit(types.FETCH_MEDIA_PENDING);

    try {
      const lang = rootState.user.language;

      const [pressReleasesDe, pressReleasesIt, mediaReports, mediaKits] = await Promise.all([
        dispatch('fetchPressReleasesDe'),
        dispatch('fetchPressReleasesIt'),
        dispatch('fetchMediaReports', lang),
        dispatch('fetchMediaKits', lang),
      ]);

      const pressReleases = {
        de: pressReleasesDe.data.data,
        it: pressReleasesIt.data.data,
      };

      commit(types.FETCH_PRESS_RELEASES_FULFILLED, pressReleases);
      commit(types.FETCH_MEDIA_REPORTS_FULFILLED, mediaReports.data.data);
      commit(types.FETCH_MEDIA_KITS_FULFILLED, mediaKits.data.data);

      commit(types.FETCH_MEDIA_FULFILLED);
    } catch (error) {
      commit(types.FETCH_MEDIA_ERROR);
    }
  },
  fetchPressReleasesDe() {
    return axios.get(`${apiDomain}media/pressreleases/de`);
  },
  fetchPressReleasesIt() {
    return axios.get(`${apiDomain}media/pressreleases/it`);
  },
  // eslint-disable-next-line
  fetchMediaReports({}, language) {
    return axios.get(`${apiDomain}media/mediareports/${language}`);
  },
  // eslint-disable-next-line
  fetchMediaKits({}, language) {
    return axios.get(`${apiDomain}media/mediakits/${language}`);
  },
  async sendProblemReport({ commit, dispatch }, form) {
    commit(types.SEND_PROBLEM_REPORT_PENDING);
    try {
      const response = axios.post(`${apiDomain}employee/resume/jobs/${form.job_id}/complain`, form);
      commit(types.SEND_PROBLEM_REPORT_FULFILLED, response);
      dispatch('messages/showMessage', { key: 'alert.reportErrorSuccessful', color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.SEND_PROBLEM_REPORT_ERROR);
      dispatch('messages/showMessage', { key: 'alert.reportErrorError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  async fetchJob({ commit }, id) {
    commit(types.FETCH_JOB_PENDING);
    try {
      const response = await axios.get(`${apiDomain}jobs/${id}`);
      commit(types.FETCH_JOB_FULFILLED, response);
      return Promise.resolve(response.data.data);
    } catch (error) {
      commit(types.FETCH_JOB_ERROR);
      return Promise.reject(error);
    }
  },
  async fetchAvamOccupationClassifications({ commit }) {
    commit(types.FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_PENDING);
    try {
      const response = await axios.get(`${apiDomain}avam-occupation-classifications`);
      commit(types.FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_ERROR);
      return Promise.reject(error);
    }
  },
};

export default actions;
